/* Arjit4Amply: Journal article (sections/matre-article.liquid). Turns a body
   written in Shopify's normal editor into the mockup's structure:
   - every Heading 2 gets an id and a row in "In this article" (01, 02...);
   - a Heading 2 named "References" (and the numbered list / paragraphs after
     it) moves into the references section, its items get ids, and [1], [2]
     in the text become links to them;
   - block quotes get the takeaway class (styled in matre-article.css);
   - "Short answer:" box, FAQ rows, link-only button, italic medical note
     and table mobile labels (the mockup's tired-but-wired article);
   - reading time (200 words/min) and "Copy article link", as the mockup's
     journal-article.js. */
(function () {
  var prose = document.querySelector('[data-article-prose]');
  if (!prose) return;

  function slug(text) {
    return (
      text
        .toLowerCase()
        .replace(/[’']/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || 'section'
    );
  }

  // References: the "References" heading and everything after it.
  var refsSection = document.querySelector('[data-article-references]');
  var headings = Array.prototype.slice.call(prose.querySelectorAll('h2'));
  var refsHeading = headings.filter(function (h) {
    return /^references\b/i.test(h.textContent.trim());
  })[0];
  if (refsHeading && refsSection) {
    var nodes = [];
    var node = refsHeading;
    while (node) {
      nodes.push(node);
      node = node.nextElementSibling;
    }
    refsHeading.id = 'references-heading';
    nodes.forEach(function (n) {
      refsSection.appendChild(n);
    });
    refsSection.querySelectorAll('ol > li').forEach(function (li, i) {
      li.id = 'reference-' + (i + 1);
    });
    refsSection.querySelectorAll('a[href^="http"]').forEach(function (a) {
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
    });
    refsSection.hidden = false;
    headings = headings.filter(function (h) {
      return h !== refsHeading;
    });

    // [1], [2] in the text -> links to the references.
    var walker = document.createTreeWalker(prose, NodeFilter.SHOW_TEXT);
    var textNodes = [];
    while (walker.nextNode()) {
      if (/\[\d+\]/.test(walker.currentNode.nodeValue)) textNodes.push(walker.currentNode);
    }
    textNodes.forEach(function (t) {
      var frag = document.createDocumentFragment();
      t.nodeValue.split(/(\[\d+\])/).forEach(function (part) {
        var m = part.match(/^\[(\d+)\]$/);
        if (m && document.getElementById('reference-' + m[1])) {
          var a = document.createElement('a');
          a.className = 'matre-article__cite';
          a.href = '#reference-' + m[1];
          a.setAttribute('aria-label', 'Reference ' + m[1]);
          a.textContent = part;
          frag.appendChild(a);
        } else if (part) {
          frag.appendChild(document.createTextNode(part));
        }
      });
      t.parentNode.replaceChild(frag, t);
    });
  }

  // Short answer: a first paragraph starting with bold "Short answer:" sits
  // above the contents box.
  var first = prose.firstElementChild;
  var contentsBox = document.querySelector('[data-article-contents]');
  if (
    first &&
    first.tagName === 'P' &&
    first.firstElementChild &&
    first.firstElementChild.tagName === 'STRONG' &&
    /^short answer/i.test(first.textContent.trim()) &&
    contentsBox
  ) {
    first.classList.add('matre-article__short');
    contentsBox.parentNode.insertBefore(first, contentsBox);
  }

  // FAQ: after a "Frequently asked questions" heading, each bold-only
  // paragraph is a question and what follows (to the next question or
  // Heading 2) its answer -> open/close rows.
  function isNote(el) {
    return (
      el.tagName === 'P' &&
      el.children.length === 1 &&
      /^(EM|I)$/.test(el.firstElementChild.tagName) &&
      el.textContent.trim() === el.firstElementChild.textContent.trim()
    );
  }

  headings
    .filter(function (h) {
      return /^frequently asked questions/i.test(h.textContent.trim());
    })
    .forEach(function (h) {
      var el = h.nextElementSibling;
      var current = null;
      while (el && el.tagName !== 'H2' && !isNote(el)) {
        var next = el.nextElementSibling;
        var only = el.tagName === 'P' && el.children.length === 1 && el.firstElementChild.tagName === 'STRONG' && el.textContent.trim() === el.firstElementChild.textContent.trim();
        if (only) {
          current = document.createElement('details');
          current.className = 'matre-article__faq';
          var summary = document.createElement('summary');
          summary.textContent = el.textContent.trim();
          current.appendChild(summary);
          el.parentNode.replaceChild(current, el);
        } else if (current) {
          current.appendChild(el);
        }
        el = next;
      }
    });

  // A paragraph that is only a link -> button (e.g. "Get the free 7-Night Sleep Reset →").
  prose.querySelectorAll('p').forEach(function (p) {
    var links = p.querySelectorAll('a');
    if (links.length === 1 && p.textContent.trim() === links[0].textContent.trim() && !p.closest('details')) {
      p.classList.add('matre-article__action');
    }
  });

  // Italic-only final paragraph(s) -> the small medical note under the article.
  var note = document.querySelector('[data-article-note]');
  var last = prose.lastElementChild;
  while (note && last && isNote(last)) {
    var prev = last.previousElementSibling;
    last.textContent = last.textContent.trim();
    note.insertBefore(last, note.firstChild);
    note.hidden = false;
    last = prev;
  }

  // Tables: the last column's header becomes its mobile label ("When: ...").
  prose.querySelectorAll('table').forEach(function (table) {
    var ths = table.querySelectorAll('thead th');
    if (!ths.length) return;
    table.querySelectorAll('tbody tr').forEach(function (tr) {
      Array.prototype.forEach.call(tr.children, function (td, i) {
        if (ths[i]) td.setAttribute('data-label', ths[i].textContent.trim());
      });
    });
  });

  // Contents: one row per remaining Heading 2.
  var contents = document.querySelector('[data-article-contents]');
  if (contents && headings.length > 1) {
    var list = contents.querySelector('ol');
    var used = {};
    headings.forEach(function (h) {
      var id = h.id || slug(h.textContent);
      while (used[id]) id += '-2';
      used[id] = true;
      h.id = id;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = h.textContent.trim() + ' ';
      var arrow = document.createElement('span');
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '↓';
      a.appendChild(arrow);
      li.appendChild(a);
      list.appendChild(li);
    });
    if (headings.length > 6) contents.classList.add('matre-article__contents--two');
    contents.hidden = false;
  }

  prose.querySelectorAll('blockquote').forEach(function (q) {
    q.classList.add('matre-article__takeaway');
  });

  var minutes = Math.max(1, Math.ceil(prose.textContent.trim().split(/\s+/).length / 200));
  var reading = document.querySelector('[data-reading-time]');
  if (reading) reading.textContent = minutes + ' min read';

  var copy = document.querySelector('[data-copy-article]');
  if (copy) {
    copy.addEventListener('click', function () {
      var status = document.querySelector('[data-copy-status]');
      var url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.delete('view');
      url.searchParams.delete('preview_theme_id');
      navigator.clipboard
        .writeText(url.href)
        .then(function () {
          status.textContent = 'Link copied.';
        })
        .catch(function () {
          status.textContent = 'Copy the address from your browser to share this article.';
        });
    });
  }
})();
